// extracted by mini-css-extract-plugin
module.exports = {"close":"close___TBuYn","readonly":"readonly___m0sph"};